import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { getSocket } from '../../context/socket'; // adjust the path if needed
import { Avatar } from 'primereact/avatar';

const AddBoardMembersDialog = ({ members, board_id, onClose, onSuccess }) => {
    const socket = getSocket();
    const [users, setUsers] = useState([]);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    console.log("🔄 Fetch eligible users on mount", members);
    // 🔄 Fetch eligible users on mount
    useEffect(() => {
        if (socket) {
            socket.emit("fetchFilteredboardUsers", { board_id: board_id }); // ✅ send board_id
            socket.on('filteredUsersboardList', (data) => setUsers(data));
            socket.on('errorFetchingboardUsers', (err) => console.error(err));
        }
        // Pre-fill selected users from cardDetails
        // Pre-fill selected users from members by flattening
        if (members?.length > 0) {
            const normalizedMembers = members.map(m => ({
                user_id: m?.BoardMember?.user_id,
                first_name: m?.first_name,
                last_name: m?.last_name,
                profileImage: m?.profileImage
            }));
            setSelectedUsers(normalizedMembers);
        }
        return () => {
            socket?.off('filteredUsersboardList');
            socket?.off('errorFetchingboardUsers');
        };
    }, [socket]);

    console.log("🔎 Autocomplete logic", users);
    // 🔎 Autocomplete logic
    const search = (event) => {
        const query = event.query.toLowerCase();
        const filtered = users.filter(user =>
            `${user.first_name} ${user.last_name}`.toLowerCase().includes(query)
        );
        setItems(filtered);
    };

    // ➕ Add selected user to member list
    const handleUserSelect = (user) => {
        if (!selectedUsers.find(u => u.user_id === user.user_id)) {
            setSelectedUsers(prev => [...prev, user]);
        }
        setValue(null);
    };

    // 🧼 Remove user from selection
    const removeUser = (userId) => {
        setSelectedUsers(prev => prev.filter(u => u.user_id !== userId));
    };

    // 💾 Save members to card
    const handleSaveMembers = () => {
        const user_ids = selectedUsers.map(u => u.user_id);
        socket.emit('editBoardMembers', { user_ids, board_id: board_id });
        onClose();
    };


    return (
        <div >
            <div className="popup-header">
                Members
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={onClose} />
            </div>
            <div className="popup-body">
                <AutoComplete
                    value={value}
                    suggestions={items}
                    completeMethod={search}
                    field="first_name"
                    onChange={(e) => setValue(e.value)}
                    onSelect={(e) => handleUserSelect(e.value)}
                    placeholder="Search by name"
                    className="ser_EMP"
                    itemTemplate={(item) => (
                        <div className="flex align-items-center justify-content-between gap-3">
                            <img
                                src={item?.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"}
                                alt={item.first_name}
                                style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                            />
                            {" "}
                            <span>{item.first_name} {item.last_name}</span>
                        </div>
                    )}
                    selectedItemTemplate={(item) =>
                        item ? (
                            <div className="flex align-items-center justify-content-between gap-3">
                                <img
                                    src={item?.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"}
                                    alt={item.first_name}
                                    style={{ width: '20px', height: '20px', borderRadius: '50%' }}
                                />
                                <span>{item.first_name} {item.last_name}</span>
                            </div>
                        ) : ''
                    }
                />


                <div className="selected-members mt-3">
                    <p><b>Selected Members:</b></p>
                    <ul className="list-EmpLIst">
                        {selectedUsers.map(user => (
                            <li key={user.user_id} className="d-flex align-items-center justify-content-between gap-2">
                                <div className='d-flex align-items-center '>
                                    <Avatar
                                        image={user.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png'}
                                        shape="circle"
                                        size="large"
                                    />
                                    {user.first_name} {user.last_name}
                                </div>
                                <Button icon="pi pi-trash" className="p-button-text text-danger p-0 ml-2" onClick={() => removeUser(user.user_id)} />
                            </li>
                        ))}
                    </ul>
                </div>

                <Button severity='success' label="Save" className="border-0 py-1 px-3 mt-1 me-2" onClick={handleSaveMembers} />
            </div>
        </div>
    );
};

export default AddBoardMembersDialog
